import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "add_row_before",
  "use": "add_row_before-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" id=\"add_row_before\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M6 18a1 1 0 001 1h4v4a1 1 0 102 0v-4h4a1 1 0 100-2h-4v-4a1 1 0 10-2 0v4H7a1 1 0 00-1 1zM1 0a1 1 0 00-1 1v8a1 1 0 001 1h22a1 1 0 001-1V1a1 1 0 00-1-1H1zm2 2a1 1 0 00-1 1v4a1 1 0 001 1h18a1 1 0 001-1V3a1 1 0 00-1-1H3z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol